/**
 * Vehicle Selector Component
 * Isolated ride component - does not touch package system
 */
import { Car, Star, Users, Check } from 'lucide-react';

const VEHICLE_TYPES = [
  {
    id: 'standard',
    name: 'Standard',
    description: 'Affordable everyday rides',
    icon: Car,
    multiplier: 1.0,
    label: '1x'
  },
  {
    id: 'comfort',
    name: 'Comfort',
    description: 'Newer cars, extra legroom',
    icon: Star,
    multiplier: 1.3,
    label: '1.3x'
  },
  {
    id: 'xl',
    name: 'XL',
    description: 'Larger vehicles for groups',
    icon: Users,
    multiplier: 1.5,
    label: '1.5x'
  }
];

const VehicleSelector = ({ selected, onSelect, disabled = false }) => {
  return (
    <div className="grid grid-cols-3 gap-3">
      {VEHICLE_TYPES.map((vehicle) => {
        const isSelected = selected === vehicle.id;
        const Icon = vehicle.icon;
        
        return (
          <button
            key={vehicle.id}
            type="button"
            onClick={() => !disabled && onSelect(vehicle.id)}
            disabled={disabled}
            className={`p-4 rounded-xl border-2 transition-all text-left ${
              isSelected 
                ? 'border-emerald-500 bg-emerald-50' 
                : 'border-gray-200 hover:border-gray-300 bg-white'
            } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
            data-testid={`vehicle-${vehicle.id}`}
          >
            <div className="flex items-center justify-between mb-2">
              <Icon className={`w-6 h-6 ${isSelected ? 'text-emerald-600' : 'text-gray-500'}`} />
              {isSelected && <Check className="w-5 h-5 text-emerald-600" />}
            </div>
            <h4 className="font-semibold text-gray-800">{vehicle.name}</h4>
            <p className="text-xs text-gray-500 mb-1">{vehicle.description}</p>
            <span className={`text-sm font-medium ${isSelected ? 'text-emerald-600' : 'text-gray-600'}`}>
              {vehicle.label}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default VehicleSelector;
export { VEHICLE_TYPES };
